var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mt-3 mb-3"},[_c('a-steps',{style:(_vm.stepStyle),attrs:{"type":"navigation","size":"small","current":_vm.current}},_vm._l((_vm.steps),function(key){return _c('a-step',{key:key,attrs:{"title":_vm.config(key).title}},[(_vm.config(key).icon)?_c('icon',{attrs:{"slot":"icon","type":"blank"},slot:"icon"}):_vm._e()],1)}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }